export default __webpack_public_path__ + "static/eset-312ae52784ef6504d6f306221358e831.jpg";